module.exports = __webpack_public_path__ + "front/img/btn.d6d92ea6.jpg";